// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



  /* Dropdown Button */
  .dropbtn {
    background-color: #ffc107;
    color: #5d1b8d;
    padding: 16px;
    font-size: 16px;
    border: none;
    margin-right: 10px;
  }
  .dropbtn:hover {
    background-color: #ffc107;
  }
  
  /* The container <div> - needed to position the dropdown content */
  .dropdown {
    position: relative;
    display: inline-block;
  }
  
  /* Dropdown Content (Hidden by Default) */
  /* .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    min-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }
   */
  /* Show the dropdown menu on hover */
  /* .dropdown:hover .dropdown-content {
    display: block;
  }

  .dropdown-content.show {
    display: block;
  }
   */


/* 
  .dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
  }

  
  .dropdown-content {
    display: none;
  }
  
  .dropdown:hover .dropdown-content {
    display: block;
  }
   */

   .dropdown-content {
    display: block;
  }
  
  /* Optional: Adjust the positioning if needed */
  .dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
  }

  .table-scroll {
    max-height: 600px; /* Adjust this height based on your requirement */
    overflow-y: auto;
    display: inline-block;
    width: 100%;
  }
  
  .table-scroll thead th {
    position: sticky;
    top: 0;
    background-color: #fff; /* Add a background color to the header */
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */
  }
  

  .table {
    table-layout: auto; /* This allows the table to be flexible */
    width: 100%; /* This makes the table take up the full width of its container */
}

.table th, .table td {
    width: auto; /* This allows the table cells to be flexible */
    overflow: auto; /* This allows the content to be scrollable if it overflows */
}
`, "",{"version":3,"sources":["webpack://./src/components/diff/diff.css"],"names":[],"mappings":";;;;EAIE,oBAAoB;EACpB;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;;EAEA,kEAAkE;EAClE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,yCAAyC;EACzC;;;;;;;;IAQE;EACF,oCAAoC;EACpC;;;;;;;IAOE;;;AAGJ;;;;;;;;;;;;;;;IAeI;;GAED;IACC,cAAc;EAChB;;EAEA,+CAA+C;EAC/C;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,iBAAiB,EAAE,iDAAiD;IACpE,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,sBAAsB,EAAE,yCAAyC;IACjE,6CAA6C,EAAE,kCAAkC;EACnF;;;EAGA;IACE,kBAAkB,EAAE,yCAAyC;IAC7D,WAAW,EAAE,iEAAiE;AAClF;;AAEA;IACI,WAAW,EAAE,+CAA+C;IAC5D,cAAc,EAAE,6DAA6D;AACjF","sourcesContent":["\r\n\r\n\r\n\r\n  /* Dropdown Button */\r\n  .dropbtn {\r\n    background-color: #ffc107;\r\n    color: #5d1b8d;\r\n    padding: 16px;\r\n    font-size: 16px;\r\n    border: none;\r\n    margin-right: 10px;\r\n  }\r\n  .dropbtn:hover {\r\n    background-color: #ffc107;\r\n  }\r\n  \r\n  /* The container <div> - needed to position the dropdown content */\r\n  .dropdown {\r\n    position: relative;\r\n    display: inline-block;\r\n  }\r\n  \r\n  /* Dropdown Content (Hidden by Default) */\r\n  /* .dropdown-content {\r\n    display: none;\r\n    position: absolute;\r\n    background-color: #f1f1f1;\r\n    min-width: 250px;\r\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\r\n    z-index: 1;\r\n  }\r\n   */\r\n  /* Show the dropdown menu on hover */\r\n  /* .dropdown:hover .dropdown-content {\r\n    display: block;\r\n  }\r\n\r\n  .dropdown-content.show {\r\n    display: block;\r\n  }\r\n   */\r\n\r\n\r\n/* \r\n  .dropdown-content {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n  }\r\n\r\n  \r\n  .dropdown-content {\r\n    display: none;\r\n  }\r\n  \r\n  .dropdown:hover .dropdown-content {\r\n    display: block;\r\n  }\r\n   */\r\n\r\n   .dropdown-content {\r\n    display: block;\r\n  }\r\n  \r\n  /* Optional: Adjust the positioning if needed */\r\n  .dropdown-content {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n  }\r\n\r\n  .table-scroll {\r\n    max-height: 600px; /* Adjust this height based on your requirement */\r\n    overflow-y: auto;\r\n    display: inline-block;\r\n    width: 100%;\r\n  }\r\n  \r\n  .table-scroll thead th {\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: #fff; /* Add a background color to the header */\r\n    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */\r\n  }\r\n  \r\n\r\n  .table {\r\n    table-layout: auto; /* This allows the table to be flexible */\r\n    width: 100%; /* This makes the table take up the full width of its container */\r\n}\r\n\r\n.table th, .table td {\r\n    width: auto; /* This allows the table cells to be flexible */\r\n    overflow: auto; /* This allows the content to be scrollable if it overflows */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
